import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import axios from "../api/axios";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Maintenance_request from "../../components/Maintenance_request";

// Vendor-facing entry point for creating a maintenance request. It loads the
// vendor's assigned properties and contact info, then hands them to the shared
// Maintenance_request form in "vendor" mode so the experience stays in lockstep
// with the public intake form.
const CreateMaintenanceRequest = (props) => {
  const [properties, setProperties] = useState([]);
  const [contact, setContact] = useState({ name: "", email: "", phone: "" });
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await axios.get("/vendor/assigned-properties");
        if (!mounted) return;
        if (res.data.status === 200) {
          setProperties(res.data.properties || []);
          setContact(res.data.vendor || { name: "", email: "", phone: "" });
        } else {
          setError(res.data.message || "Unable to load your assigned properties.");
        }
      } catch (e) {
        if (mounted) setError("Unable to load your assigned properties.");
      } finally {
        if (mounted) setLoaded(true);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  const handleSubmitted = () => {
    if (props.history && props.history.push) {
      props.history.push("/working-tickets");
    } else {
      window.location.href = "/working-tickets";
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs
          title="Maintenance"
          breadcrumbItem="Create Maintenance Request"
        />
        {!loaded ? (
          <p>Loading…</p>
        ) : error ? (
          <p className="text-danger">{error}</p>
        ) : properties.length === 0 ? (
          <p>
            You have no assigned properties. Please contact your property manager
            to be assigned to a property before creating a request.
          </p>
        ) : null}
      </Container>
      {loaded && !error && properties.length > 0 && (
        <Maintenance_request
          mode="vendor"
          properties={properties}
          lockedContact={contact}
          onSubmitted={handleSubmitted}
        />
      )}
    </div>
  );
};

export default CreateMaintenanceRequest;
